import React from 'react';
import './card-promo.scss';
import Redirect from '../../../shared/components/atoms/redirect/redirect';
import { utilGtm } from '../../../shared/utils/utilGtm';

const CardPromo = props => {
    const { promo } = props;

    return (
        <div className="a-card-promo">
            <div className="a-card-promo_logo-container">
                <img src={ promo.logo.file.url } alt={ promo.titulo }/>
            </div>
            <h3 className="custom-h h6">{ promo.titulo }</h3>
            <p>{ promo.texto }</p>
            {/* promo.llamadaALaAccion */}
            <Redirect gtm={  utilGtm('gtmPromocionesClicTodas', promo.slug) } url={ `promociones/${ promo.slug }` } className="button">
                CONOCE MÁS
            </Redirect>
            {
                promo.enlaceBotonSecundario ?
                <Redirect 
                    url={ promo.enlaceBotonSecundario } className="link"
                    gtm={ utilGtm('gtmPromocionClicSecundario', promo.slug) }    
                >
                    { promo.textoBotonSecundario }
                </Redirect> : <div className="space"></div>
            }
        </div>
    )
}

export default CardPromo
